import { NavigateFunction, Location } from "react-router-dom";

export function replaceWithFrom(
	navigate: NavigateFunction,
	location?: Location
): void {
	const locationState = location?.state as never;
	if (locationState && "pathname" in locationState) {
		const { pathname } = locationState;
		navigate(pathname, { state: locationState, replace: true });
	} else {
		navigate("/", { replace: true });
	}
}
